import React, { useEffect } from 'react';
//import { useParams } from 'react-router';
import { Flex } from '@gjensidige/builders-components';
import { AppConfigSet } from '@gjensidige/se-content-helpers';
import {
  apiCallBegan,
  APICallMethods
} from '@gjensidige/se-redux-api-middleware';

import { useAppDispatch } from '../../../hooks/appHooks';
import { checkCustomerEligibility } from '../../../lib/api';
import AppConstants from '../../../lib/constants/appConstants';
import { API_OPERATIONS } from '../../../lib/constants/appConstants';
import { SESSION_KEYS } from '../../../lib/constants/appConstants';
import API_ENDPOINTS from '../../../lib/constants/endpoints';
import ROUTES from '../../../lib/constants/routes';
import {
  onApiBegan,
  onApiError,
  onApiSuccess,
  setCouponInfo,
  setCustomerName,
  setMetaDataStatus,
  updateCprNumber,
  updateErrorStatus,
  updateLoadingStatus
} from '../../../store/slices/offerSlice';
import './InsuranceStep.scss';
import { MoreInputsPage } from '../../../pages/MoreInputsPage';
import { OfferPage } from '../../../pages/OfferPage';
import { SummaryPage } from '../../../pages/SummaryPage';
import { WelcomeBackPage } from '../../../pages/WelcomeBackPage';
import { APIHelper } from '../../../utils/ApiHelper';
import { InsuranceHelper } from '../../../utils/InsuranceHelper';
import { PageNotFound } from '../../../pages/PageNotFound';
interface UrlParams {
  product: string;
  page: string;
}

//set proper channel in session storage when land from saved offer/rikshem offer
let { channel } = InsuranceHelper.getPolicyAndChannelFromUrl();

if (channel) {
  const customerInfo = JSON.parse(
    sessionStorage.getItem(SESSION_KEYS.CUSTOMER_INFO) || '{}'
  );
  sessionStorage.setItem(SESSION_KEYS.CUSTOMER_INFO, 
    JSON.stringify({...customerInfo, channel})
  )
} else {
  channel = InsuranceHelper.getChannelInfo()
}

const InsuranceStep: React.FC<UrlParams> = ({product, page}: UrlParams) => {
  //const { product, page } = useParams();

  const dispatch = useAppDispatch();

  useEffect(() => {

    

    const fetchTextsAndConfigs = async () => {
      await Promise.all([
        fetchAppTexts(),
        dispatch(
          apiCallBegan({
            init: '',
            url: API_ENDPOINTS.getProductConfigUrl(product),
            apiOperation: API_OPERATIONS.GET_PRODUCT_CONFIG,
            method: APICallMethods.GET_CDN_CONTENT,
            onStart: onApiBegan.type,
            onSuccess: onApiSuccess.type,
            onError: onApiError.type
          })
        ),

        dispatch(
          apiCallBegan({
            init: '',
            url: API_ENDPOINTS.getQuestionsConfigUrl(product, channel),
            apiOperation: API_OPERATIONS.GET_QUESTION_CONFIG,
            method: APICallMethods.GET_CDN_CONTENT,
            onStart: onApiBegan.type,
            onSuccess: onApiSuccess.type,
            onError: onApiError.type
          })
        )
      ]);
    };

    const fetchAppTexts = async () => {
      await Promise.resolve(
        dispatch(
          apiCallBegan({
            init: {
              applicationName: 'webshop-se',
              configSet: [AppConfigSet.GENERIC_ILLUSTRATION]
            },
            url: '',
            apiOperation: API_OPERATIONS.GET_APP_TEXTS,
            method: APICallMethods.GET_APP_SETUP,
            onStart: onApiBegan.type,
            onSuccess: onApiSuccess.type,
            onError: onApiError.type
          })
        )
      );
    };
    const fetchTemplateData = async (product: string) => {
      await Promise.resolve(
        dispatch(
          apiCallBegan({
            init: APIHelper.getTemplatePayload(product),
            url: API_ENDPOINTS.getMetaDataURl(),
            apiOperation: API_OPERATIONS.GET_TEMPLATE_DATA,
            method: APICallMethods.POST_JSON,
            onStart: onApiBegan.type,
            onSuccess: onApiSuccess.type,
            onError: onApiError.type
          })
        )
      );
    };

    const fetchInitialData = async () => {
      await fetchTextsAndConfigs();
      if (page !== ROUTES.welcomeBack && page !== ROUTES.welcome) {
        await fetchTemplateData(product);
        dispatch(setMetaDataStatus(true));
      } else {
        dispatch(setMetaDataStatus(true));
      }

      const customerInfo = JSON.parse(
        sessionStorage.getItem(SESSION_KEYS.CUSTOMER_INFO) || '{}'
      );
      if (customerInfo && customerInfo.cprNumber) {
        dispatch(updateCprNumber(customerInfo.cprNumber));
      }
      const policyInfo = InsuranceHelper.retrievePolicyInfoFromURL();
      if (policyInfo.couponCode) {
        dispatch(
          setCouponInfo({
            couponCode: policyInfo.couponCode,
            couponDiscountPercentage: policyInfo.couponDiscountPercentage
          })
        );
      }
      // if (customerInfo && customerInfo.customerName) {
      //   dispatch(setCustomerName(customerInfo.customerName));
      // }
    };
    const checkCustomerEligibilityForProduct = async () => {
      const eligibilityInfo = await checkCustomerEligibility(
        APIHelper.getCustomerEligibilityPayload(product)
      );
      return eligibilityInfo;
    };
    if (!InsuranceHelper.isCustomerEligibilityCheckEnabled(product, page)) {
      fetchInitialData();
    } else {
      checkCustomerEligibilityForProduct().then((eligibilityInfo) => {
        if (eligibilityInfo.eligible) {
          if (eligibilityInfo.customerName) {
            dispatch(setCustomerName(eligibilityInfo.customerName));
          }
          fetchInitialData();
        } else {
          fetchAppTexts().then(() => {
            dispatch(
              updateErrorStatus(
                InsuranceHelper.buildErrorMessage(
                  eligibilityInfo.errorTitle,
                  eligibilityInfo.errorMessage,
                  eligibilityInfo.errorStatus
                )
              )
            );
            dispatch(updateLoadingStatus('failed'));
          });
        }
      });
    }
    window.scrollTo(0, 0);
  }, []);

  const renderPage = () => {
    let template;
    switch (page) {
      case ROUTES.offerPage:
        template = <OfferPage product={product} />;
        break;
      case ROUTES.moreInputsPage:
        template = <MoreInputsPage product={product} />;
        break;
      case ROUTES.summaryPage:
        template = <SummaryPage product={product} />;
        break;
      case ROUTES.welcomeBack:
        template = <WelcomeBackPage product={product} redirectPage={ROUTES.summaryPage} appModuleToTrack="checkout"/>;
        break;
      case ROUTES.welcome:
        template = <WelcomeBackPage product={product} redirectPage={ROUTES.moreInputsPage} appModuleToTrack="offer"/>;
        break;
      default:
        template = <PageNotFound />;
        break;
    }
    return template;
  };

  return AppConstants.productList.includes(product) ? (
    <>{renderPage()}</>
  ) : (
    <PageNotFound />
  );
};

export default InsuranceStep;
